// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { purchasedProductCardStyles } from "@west/Overrides/Components/PurchasedProductCard";
import { xScreen } from "@west/XDL/Utilities";
import { FontWeightProperty } from "csstype";
import { css } from "styled-components";

const sharedLabelStyle = {
    size: 14,
    lineHeight: "22px",
    weight: "normal" as FontWeightProperty,
    css: css`
        margin-right: 4px;
    `,
};

const sharedValueStyle = {
    size: 14,
    lineHeight: "22px",
};

purchasedProductCardStyles.leftColumnGridItem = {
    width: [4, 4, 3, 3, 3],
    css: css`
        padding-right: 15px;
    `,
};
purchasedProductCardStyles.rightColumnGridItem = {
    width: [8, 8, 9, 9, 9],
    css: css`
        flex-direction: column;
        padding-right: 15px;
        ${xScreen("lte", "sm")} {
            &&&& {
                padding-right: 0;
            }
        }
    `,
};

purchasedProductCardStyles.infoGridItem = {
    width: [12, 12, 6, 6, 6],
};

purchasedProductCardStyles.descriptionStyles = {
    productDetailLink: {
        typographyProps: {
            lineHeight: "16px",
            css: css`
                margin-bottom: 8px;
            `,
        },
    },
};

purchasedProductCardStyles.partNumbersStyles = {
    customerNameLabelText: {
        ...sharedLabelStyle,
    },
    customerNameValueText: {
        ...sharedValueStyle,
    },
    manufacturerItemLabelText: {
        ...sharedLabelStyle,
    },
    manufacturerItemValueText: {
        ...sharedValueStyle,
    },
};

purchasedProductCardStyles.availabilityStyles = {
    inventoryMessage: {
        css: css`
            margin: 4px 0;
        `,
    },
};

purchasedProductCardStyles.priceGridItem = {
    width: [12, 12, 3, 2, 2],
    css: css`
        flex-direction: column;

        ${xScreen("lte", "sm")} {
            &&&& {
                margin-top: 8px;
            }
        }
    `,
};

purchasedProductCardStyles.priceStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: auto;
            text-align: end;
            margin-bottom: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            align-self: flex-end;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    priceLabelText: {
        size: 14,
        lineHeight: "21px",
        weight: "bold",
    },
};

purchasedProductCardStyles.quantityGridItem = {
    width: [12, 12, 1, 2, 2],
    css: css`
        justify-content: center;

        ${xScreen("lte", "sm")} {
            justify-content: left;
            &&&& {
                margin: 8px 0;
            }
        }
    `,
};

purchasedProductCardStyles.addToGridItem = {
    width: [12, 12, 2, 2, 2],
    css: css`
        flex-direction: column;
        align-items: center;
    `,
};
